<div class="direct-rfq">
  <div class="direct-rfq__menu-bar">
    <div class="direct-rfq__menu-bar__title">Direct RFQ</div>
    <button
      class="direct-rfq__menu-bar__right-button-close"
      (click)="closeRfq()"
    ></button>
  </div>
  <ng-container *ngTemplateOutlet="tabInfo"></ng-container>
  <ng-container *ngTemplateOutlet="legsContainer"></ng-container>
  <ng-container *ngTemplateOutlet="submitContainer"></ng-container>
  <ng-container
    *ngTemplateOutlet="
      prices;
      context: {
        rfqQuotes: quotes,
        currentTime: currentTimestamp,
        quotesFrozen: frozenQuotes
      }
    "
  ></ng-container>
  <ng-container *ngTemplateOutlet="indicativeMarketData"></ng-container>
</div>

<ng-template #tabInfo>
  <div class="direct-rfq__tab-info">
    <span
      class="direct-rfq__tab-info__status"
      *ngIf="rfqTab.title.status.statusType || false"
    >
      <label>Status:</label>
      <span
        [@tabStatus]="rfqTab.title.status.statusType"
        class="direct-rfq__tab-info__status__value"
        [ngClass]="rfqTab.title.status.statusType"
      >
        {{ rfqTab.title.status.statusType }}
      </span>
    </span>

    <span
      class="direct-rfq__tab-info__count-down {{
        rfqTab.title.status.statusExtra | countDownColorClass
      }}"
    >
      {{ mainTimer?.timer$ | async | secondsToMinutes }}
    </span>
  </div>
</ng-template>

<ng-template #submitContainer>
  <div class="direct-rfq__submit-container">
    <span>{{ rfqTab.positions.bid }}</span>
    <button
      class="ui-button"
      [disabled]="!legValid || !legPrice"
      [ngClass]="isRfqRunning ? 'ui-button--danger' : 'primary'"
      (click)="isRfqRunning ? cancelRfq() : startRfq()"
    >
      {{ isRfqRunning ? 'Cancel' : 'RFQ' }}
    </button>
    <span>{{ rfqTab.positions.offer }}</span>
  </div>
</ng-template>

<ng-template #legsContainer>
  <div class="direct-rfq__legs-container" *ngIf="legs">
    <div class="attributes">
      <active-attributes [rfqExecution]="true"></active-attributes>
    </div>
    <ng-container *ngFor="let leg of legs; index as i">
      <app-leg
        [legIndex]="i"
        [leg]="leg"
        class="leg-container"
        [ngClass]="{ 'leg-container--dim': !leg.checked }"
        [rfqExecutionSettings]="rfqExecutionSettings"
        (changeInLeg)="onChangeInLegs()"
        (fieldBlurred)="onChangeInLegs()"
      >
      </app-leg>
    </ng-container>
  </div>
</ng-template>

<ng-template #indicativeMarketData>
  <div
    class="direct-rfq__indicative-market-data-loading"
    *ngIf="!!legComponents?.first.leg.disablePricingButton"
  >
    <span class="spinner spinner-md spinner-inverse"> </span>
  </div>
  <div class="direct-rfq__indicative-market-data" *ngIf="legPrice">
    <label class="forward-point">Forward Point</label>
    <label class="forward-point-bid">{{
      legPrice.marketData[0].forwardPoints.bid | number : '1.2-2'
    }}</label>
    <label class="forward-point-ask">{{
      legPrice.marketData[0].forwardPoints.ask | number : '1.2-2'
    }}</label>
    <label class="volatility">Volatility</label>
    <label class="volatility-bid">
      {{ legPrice.marketData[0].strikeVol.bid | percent : '1.2-2' }}
    </label>
    <label class="volatility-ask">
      {{ legPrice.marketData[0].strikeVol.ask | percent : '1.2-2' }}
    </label>
  </div>
</ng-template>

<ng-template
  #prices
  let-rfqQuotes="rfqQuotes"
  let-currentTime="currentTime"
  let-quotesFrozen="quotesFrozen"
>
  <div
    class="direct-rfq__prices"
    *ngIf="rfqQuotes.bids.length || rfqQuotes.offers.length || legPrice"
  >
    <ng-container
      *ngTemplateOutlet="
        quotesTmpl;
        context: {
          side: 'bid',
          quote:
            (quotesFrozen && rfqTab.title.status.statusType !== 'Cancelled') ||
            rfqQuotes.bids[0]?.timeLimit >= currentTime
              ? rfqQuotes.bids[0]
              : indicativeQuoteBid
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        quotesTmpl;
        context: {
          side: 'ask',
          quote:
            (quotesFrozen && rfqTab.title.status.statusType !== 'Cancelled') ||
            rfqQuotes.offers[0]?.timeLimit >= currentTime
              ? rfqQuotes.offers[0]
              : indicativeQuoteAsk
        }
      "
    ></ng-container>
  </div>
</ng-template>

<ng-template #quotesTmpl let-quote="quote" let-side="side">
  <ng-container *ngIf="quote">
    <div
      class="direct-rfq__prices__indicative-sign"
      *ngIf="quote.status === 'Indicative' && side === 'bid'"
    >
      Indicative
    </div>

    <div
      class="direct-rfq__prices__quote-section {{ quote?.status }}"
      [ngClass]="{
        'direct-rfq__prices__quote-section--reverse':
          quote.bidAsk.type === 'Pay',
        'direct-rfq__prices__quote-section--half':
          indicativeQuoteBid && indicativeQuoteAsk
      }"
      [@quoteActionAnimation]="quote?.status"
    >
      <div class="direct-rfq__prices__quote-section__rfe-status">
        <ng-container [ngSwitch]="quote?.status">
          <span
            class="response-block response-sent"
            *ngSwitchCase="'ConfirmRFESent'"
          >
            <span class="spinner spinner-sm"> Loading... </span>
            <span class="response-text">RFE Sent</span>
          </span>
          <span
            class="response-block response-success"
            *ngSwitchCase="'ConfirmRFEAccept'"
          >
            <cds-icon class="check" shape="check"></cds-icon>
            <span class="response-text response-text--success">
              Trade Done
            </span>
          </span>
          <span
            class="response-block response-declined"
            *ngSwitchCase="'ConfirmRFEDecline'"
          >
            <cds-icon class="declined" shape="ban"></cds-icon>
            <span class="response-text response-text--declined">
              RFE Declined
            </span>
          </span>
        </ng-container>
      </div>
      <button
        class="ui-button primary direct-rfq__prices__quote-section__price-button"
        [ngClass]="{
          'direct-rfq__prices__quote-section__price-button--not-running':
            isRfqRunning,
          'direct-rfq__prices__quote-section__price-button--finished':
            quote.status === 'Indicative' &&
            (quote.status === 'ConfirmRFEAccept' ||
              quote.status === 'ConfirmRFENotSent'),
          'direct-rfq__prices__quote-section__price-button--not-indicative':
            quote.status === 'Indicative',
          'direct-rfq__prices__quote-section__price-button--rfe-sent':
            quote.status === 'ConfirmRFESent' ||
            quote.status === 'ConfirmRFEAccept',
          'direct-rfq__prices__quote-section__price-button--rfe-not-sent':
            quote.status === 'ConfirmRFENotSent'
        }"
        [disabled]="
          quote.status === 'Indicative' || quote?.status !== 'Default'
        "
        (click)="rfeRequest(quote)"
        *ngIf="quote"
      >
        <div
          class="direct-rfq__prices__quote-section__price-button__text-container"
        >
          <label
            class="side"
            [ngClass]="
              quote.bidAsk.type === 'Pay' ? 'side--pay' : 'side--receive'
            "
          >
            {{ quote.bidAsk.type }}
          </label>
          <label class="vol">
            <ng-container
              *ngIf="
                quote.status === 'Indicative' &&
                  quote.quotedPremiumSection.showPercent;
                else defaultPremiumTmpl
              "
            >
              {{
                quote.quotedPremiumSection.quotedPremium
                  | abs
                  | percent : '1.3-3'
              }}
            </ng-container>

            <ng-template #defaultPremiumTmpl>
              <ng-container *ngIf="quote.quotedPremiumSection?.quotedPremium">
                {{
                  quote.quotedPremiumSection.quotedPremium
                    | abs
                    | number
                      : (quote.quotedPremiumSection.showPercent
                          ? '1.3-3'
                          : '1.1-1')
                }}
                {{ quote.quotedPremiumSection.showPercent ? '%' : '' }}
              </ng-container>
            </ng-template>

            {{ quote.quotedPremiumSection?.currency }}
          </label>
          <label class="price">
            {{ quote.bidAsk.amount | number : '1.2-2' }}
            {{ quote.bidAsk.currency }}
          </label>

          <span class="bank-button-text" *ngIf="quote.bidAsk.marginSpread">
            ({{ quote.bidAsk.marginSpread | percent : '1.4-4' }})
          </span>
        </div>
      </button>
    </div>
  </ng-container>
</ng-template>

<app-warning-screen
  *ngIf="warningScreenData.warningScreenOpen"
  [isModalOpened]="warningScreenData.warningScreenOpen"
  [headerMessage]="warningScreenData.headerMessage"
  [messageToDisplay]="warningScreenData.messageToDisplay"
  [yesNoOptions]="false"
  (communicate)="warningScreenResponse()"
  (warningOpenChanged)="warningScreenResponse($event)"
></app-warning-screen>
